export const state = () => ({
	jobs: [],
	application_limit: 2,
});

export const mutations = {
	setJobs(state: any, payload: any) {
		state.jobs = payload;
	},

	setApplicationLimit(state: any, payload: any) {
		state.application_limit = payload;
	},
};

export const getters = {
	getJobs: (state: any) => state.jobs,
	getApplicationLimit: (state: any) => state.application_limit,
};

export const actions = {
	getJobs(state: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/shortlist-me/jobs')
				.then((res) => {
					state.commit('setJobs', res.data.data);
					state.commit('setApplicationLimit', res.data.meta.application_limit);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	applyForJobInterview(state: any, job_id: Number) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/shortlist-me/jobs/${job_id}/applications`)
				.then(async (res) => {
					try {
						await state.dispatch('getJobs');
						resolve(res.data);
					} catch (err) {
						reject(err);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
